import CustomImage from "@/components/CustomImage";
import React, { useState } from "react";
import { Swiper as SwiperCore } from "swiper";
import { Swiper, SwiperSlide } from "swiper/react";
import GalleryButtons from "../GalleryButtons";
import { GalleryImageType } from "..";

type GalleryModalSliderProps = {
  activeImageId: number;
  images: GalleryImageType[];
};

const GalleryModalSlider = ({
  activeImageId,
  images,
}: GalleryModalSliderProps) => {
  const [isNavigationVisible, setIsNavigationVisible] = useState(true);
  const [disablePrev, setDisablePrev] = useState(true);
  const [disableNext, setDisableNext] = useState(false);

  const handleSlideChange = (swiper: SwiperCore) => {
    setDisablePrev(swiper.isBeginning);
    setDisableNext(swiper.isEnd);
  };
  const checkSlidesCount = (swiper: SwiperCore) => {
    const slidesPerView = swiper.params.slidesPerView;
    const enoughSlides = swiper.slides.length > Number(slidesPerView);
    setIsNavigationVisible(enoughSlides);
  };
  return (
    <>
      <Swiper
        slidesPerView={1}
        spaceBetween={10}
        navigation={true}
        className="gallery__swiper"
        initialSlide={activeImageId - 1}
        onInit={(swiper) => checkSlidesCount(swiper)}
        onResize={(swiper) => checkSlidesCount(swiper)}
        onSlideChange={(swiper: SwiperCore) => handleSlideChange(swiper)}
      >
        {images.map((image) => (
          <SwiperSlide key={image.id} className="gallery__modal-swiper-item">
            <CustomImage
              alt={image.image.alt}
              src={image.image.src.desktop}
              srcTablet={image.image.src.tablet}
              srcMobile={image.image.src.mobile}
              className="image--bg"
            />
          </SwiperSlide>
        ))}
        {isNavigationVisible ? (
          <GalleryButtons disableNext={disableNext} disablePrev={disablePrev} />
        ) : null}
      </Swiper>
    </>
  );
};

export default GalleryModalSlider;
